"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Controls = exports["default"] = /*#__PURE__*/function (_React$Component) {
  _inherits(Controls, _React$Component);
  function Controls() {
    _classCallCheck(this, Controls);
    return _callSuper(this, Controls, arguments);
  }
  _createClass(Controls, [{
    key: "_renderSave",
    value: function _renderSave() {
      if (!this.props.showSave) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.save,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-floppy-disk"
      }), " Save");
    }
  }, {
    key: "_renderGenerateTimings",
    value: function _renderGenerateTimings() {
      if (!this.props.generateTimings) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.generateTimings,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-repeat"
      }), " Regenerate");
    }
  }, {
    key: "_renderRemoveTimings",
    value: function _renderRemoveTimings() {
      if (!this.props.removeTimings) {
        return null;
      }
      return /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.removeTimings,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-trash"
      }), " Remove");
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-primary",
        onClick: this.props.onSubmit
      }, "Submit"), this._renderSave(), this._renderGenerateTimings(), this._renderRemoveTimings())), /*#__PURE__*/_react["default"].createElement("p", null, /*#__PURE__*/_react["default"].createElement("div", {
        className: "btn-group"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.goToStart,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-fast-backward"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.goBack,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-backward"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.play,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: this.props.playing ? 'glyphicon glyphicon-pause' : 'glyphicon glyphicon-play'
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.goForward,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-forward"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.goEnd,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-fast-forward"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.zoomIn,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-zoom-in"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.zoomOut,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-zoom-out"
      })), /*#__PURE__*/_react["default"].createElement("button", {
        onClick: this.props.reset,
        type: "button",
        className: "btn btn-default"
      }, /*#__PURE__*/_react["default"].createElement("span", {
        className: "glyphicon glyphicon-refresh"
      }), " Undo Edits"))));
    }
  }]);
  return Controls;
}(_react["default"].Component);
_defineProperty(Controls, "propTypes", {
  goToStart: _propTypes["default"].func.isRequired,
  goBack: _propTypes["default"].func.isRequired,
  play: _propTypes["default"].func.isRequired,
  goForward: _propTypes["default"].func.isRequired,
  goEnd: _propTypes["default"].func.isRequired,
  reset: _propTypes["default"].func.isRequired,
  save: _propTypes["default"].func.isRequired,
  playing: _propTypes["default"].bool.isRequired,
  zoomIn: _propTypes["default"].func.isRequired,
  zoomOut: _propTypes["default"].func.isRequired,
  showSave: _propTypes["default"].bool,
  generateTimings: _propTypes["default"].func,
  removeTimings: _propTypes["default"].func,
  onSubmit: _propTypes["default"].func
});